import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Trophy from './trophy-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Trophy {...validProps} />;
}
SvgComponent.iconName = 'trophy';

/**
 * @deprecated This is a legacy icon
 */
export const TrophyIcon = svgIconWrapper(SvgComponent);
